/**
 * Normalize STT / ASR transcript text for display.
 * Some Thai speech models emit syllable separators as `_` or U+2581 (▁).
 */
export function normalizeTranscriptText(input: unknown): string {
  if (input == null) return "";
  let s = String(input);
  if (!s) return "";

  s = s.replace(/\u2581/g, " ");

  if (s.includes("_")) {
    const underscoreCount = (s.match(/_/g) || []).length;
    if (underscoreCount >= 2) {
      s = s.replace(/_/g, " ");
    }
  }

  return s.replace(/\s+/g, " ").trim();
}
